// @ts-nocheck
import {
  LOGIN_REQUEST,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  SEND_OTP_REQUEST,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILURE,
  VERIFY_FORGET_OTP_REQUEST,
  VERIFY_FORGET_OTP_SUCCESS,
  VERIFY_FORGET_OTP_FAILURE,
  REFRESH_TOKEN,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  FETCH_USER_PROFILE_DETAILS_REQUEST,
  FETCH_USER_PROFILE_DETAILS_SUCCESS,
  FETCH_USER_PROFILE_DETAILS_FAILURE,
  UPDATE_USER_DATA,
  SET_2FA_SUCCESS,
  SET_2FA_REQUEST,
  SET_2FA_FAILURE,
  REFRESH_USER,
  CHANGE_NOTIFICATION_REQUEST,
  CHANGE_NOTIFICATION_SUCCESS,
  CHANGE_NOTIFICATION_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  UPDATE_IMAGE_REQUEST,
  UPDATE_IMAGE_SUCCESS,
  UPDATE_IMAGE_FAILURE,
  FETCH_CONTRACTOR_PROFILE_REQUEST,
  FETCH_CONTRACTOR_PROFILE_SUCCESS,
  FETCH_CONTRACTOR_PROFILE_FAILURE,
  UPDATE_CONTRACTOR_PROFILE_STEPS,
  UPDATE_MULTIPLE_FIELDS_AUTH,
  UPDATE_CONTRACTOR_CERTIFICATES,
  CHANGE_PUSH_NOTIFICATION_REQUEST,
  CHANGE_PUSH_NOTIFICATION_SUCCESS,
  CHANGE_PUSH_NOTIFICATION_FAILURE,
  TOGGLE_HELP_STATUS,
  ACCEPT_CONTRACTOR_CONSENT_REQUEST,
  ACCEPT_CONTRACTOR_CONSENT_FAILURE,
  ACCEPT_CONTRACTOR_CONSENT_SUCCESS,
  RESET_AUTH,
  CLIENT_SIGNUP_REQUEST,
  CLIENT_SIGNUP_SUCCESS,
  CLIENT_SIGNUP_FAILURE,
  UPDATE_EMAIL_PREFERENECE_STATUS_REQUEST,
  UPDATE_EMAIL_PREFERENECE_STATUS_FAILURE,
  UPDATE_EMAIL_PREFERENECE_STATUS_SUCCESS,
  FETCH_PROFILE_SUCCESS,
  FIREBASE_SUPPORT_STATUS,
  ACCEPT_CONTRACTOR_DOCUMENTS_REQUEST,
  ACCEPT_CONTRACTOR_DOCUMENTS_SUCCESS,
  ACCEPT_CONTRACTOR_DOCUMENTS_FAILURE,
  SWITCH_ACTIVE_ROLE_REQUEST,
  SWITCH_ACTIVE_ROLE_SUCCESS,
  SWITCH_ACTIVE_ROLE_FAILURE,
} from "../constants/auth";

import { userRoles } from "../../staticData/userRoles";

const initialState = {
  userToken: null,
  refreshToken: null,
  loading: false,
  hasError: null,
  userName: null,
  imageUrl: null,
  email: null,
  phoneNumber: null,
  companyName: null,
  resumeUrl: null,
  insuranceCertificate: null,
  age: null,
  dateOfBirth: null,
  emergencyContactName: null,
  emergencyContactNumber: null,
  isTwoFactorAuthentication: false,
  createdAt: null,
  userId: null,
  /**
   * @deprecated Kept only for backward compatibility with components that still read
   * `auth.userRole`. Synced with `activeRole` on LOGIN_SUCCESS so nothing
   * breaks. Will be removed in Step 14 (cleanup) along with the FE codemod.
   */
  userRole: null,
  // Multi-role state (post-unification)
  /** Current UI role. Governs layout/sidebar (does NOT govern permissions). */
  activeRole: null,
  /** List of approved roles — source of truth for permission checks. */
  approvedRoles: [],
  /** List of pending roles — for the UI to show "awaiting approval". */
  pendingRoles: [],
  /** Data specific to each approved role. Map role → data. */
  rolesData: {},
  /** Loading state for the switchActiveRole action. */
  switchingRole: false,
  userProfileDetailsLoading: false,
  isTwoFactorAuthenticationLoading: false,
  sLoading: false,
  notificationPreference: null,
  pLoading: false,
  contractorDetails: {},
  contractorLoading: false,
  logoutLoading: false,
  helpStatus: false,
  isFirebaseSupported: true,
  isNotificationDenied: false,
  canViewCrewIdentityDocuments: false,
  canManageDeposits: false,
  canManageFinancialDrafts: false,
  canViewFinancialDashboard: false,
  canViewPayrollDashboard: false,
  canManageFinancialCloseout: false,
  canManageRecruitment: false,
  emailPref: {
    clientEmailNotificationNecessaryPreference: {},
    clientEmailNotificationOptionalPreference: {},
    blockAllEmails: false,
  },
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    // Login actions start...
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        userToken: null,
        refreshToken: null,
      };
    case LOGIN_SUCCESS: {
      let contractorData = {};
      let disableDashboard = false;
      if (action.payload?.data?.activeRole === userRoles.contractor) {
        let profileCompleted = false;

        if (
          action.payload?.contractorDetails?.contractorProfile
            ?.isContractorFormCompleted &&
          action.payload?.contractorDetails?.contractorProfile
            ?.isPersonalInformationAdded &&
          action.payload?.contractorDetails?.contractorProfile
            ?.isCareerGoalsAdded &&
          action.payload?.contractorDetails?.contractorProfile
            ?.isRoleInformationAdded
        ) {
          profileCompleted = true;
        }

        if (!action?.payload?.data?.isApproved) {
          disableDashboard = true;
        }

        contractorData.profileCompleted = profileCompleted;
        contractorData.contractorProfile =
          action.payload?.contractorDetails?.contractorProfile;
      }

      return {
        ...state,
        loading: false,
        userToken: action.payload?.token,
        refreshToken: action.payload?.refreshToken,
        deviceToken: action.payload?.deviceToken,
        userName: action.payload?.data?.name,
        email: action.payload?.data?.email,
        allDeviceToken: action?.payload?.data?.deviceToken,
        phoneNumber: action.payload?.data?.mobile,
        companyName: action.payload?.data?.companyName,
        isTwoFactorAuthentication:
          action.payload?.data?.isTwoFactorAuthentication,
        createdAt: action.payload?.data?.createdAt,
        hasError: false,
        userId: action.payload?.data?.id,
        // Multi-role: backend agora envia activeRole + approvedRoles
        userRole: action.payload?.data?.activeRole,
        activeRole: action.payload?.data?.activeRole,
        approvedRoles: action.payload?.data?.approvedRoles || [],
        pendingRoles: action.payload?.data?.pendingRoles || [],
        rolesData: action.payload?.data?.rolesData || {},
        isApproved: action.payload?.data?.isApproved,
        isSupportAgent: action.payload?.data?.isSupportAgent ?? state.isSupportAgent,
        isGustoApproved: action.payload?.data?.isGustoApproved,
        isADPCompleted: action.payload?.data?.isADPCompleted,
        smsPermissionStatus: action?.payload?.data?.smsPermissionStatus,
        termsAcceptedAt: action?.payload?.data?.termsAcceptedAt,
        disableDashboard,
        imageUrl: action.payload?.data?.profileImageUrl,
        resumeUrl: action.payload?.data?.resume,
        insuranceCertificate: action.payload?.data?.insuranceCertificate,
        age: action.payload?.data?.age,
        contractorType: action?.payload?.data?.contractorType,
        dateOfBirth: action.payload?.data?.dateOfBirth,
        emergencyContactName: action.payload?.data?.emergencyContactName,
        emergencyContactNumber: action.payload?.data?.emergencyContactNumber,
        notificationPreference: {
          ...action.payload?.data?.emailNotificationPreference,
          pushNotificationPreference:
            action.payload?.data?.pushNotificationPreference,
        },
        canPositionEdit: action?.payload?.data?.canPositionEdit,
        isAgreementAccepted: action?.payload?.data?.isAgreementAccepted,
        canManageGusto: action?.payload?.data?.canManageGusto,
        canManageDeposits: action?.payload?.data?.canManageDeposits,
        canManageFinancialDrafts: action?.payload?.data?.canManageFinancialDrafts === true,
        canViewFinancialDashboard: action?.payload?.data?.canViewFinancialDashboard === true,
        canViewPayrollDashboard: action?.payload?.data?.canViewPayrollDashboard === true,
        canManageFinancialCloseout: action?.payload?.data?.canManageFinancialCloseout === true,
        canManageRecruitment: action?.payload?.data?.canManageRecruitment,
        canViewCrewIdentityDocuments:
          action?.payload?.data?.canViewCrewIdentityDocuments,
        allowResendCredentials: action?.payload?.data?.allowResendCredentials,
        canUnflagContractors: action?.payload?.data?.canUnflagContractors,
        canUnrestrictContractors:
          action?.payload?.data?.canUnrestrictContractors,
        addAdpLink: action?.payload?.data?.addAdpLink,
        contractorDetails: contractorData,
        emailPref: action?.payload?.data?.EmailNotificationPreference,
      };
    }

    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        userToken: null,
        hasError: true,
      };
    // Login actions end...

    // Logout actions start...
    case LOGOUT_REQUEST:
      return {
        ...state,
        logoutLoading: true,
        userToken: null,
      };
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        logoutLoading: false,
        hasError: true,
      };
    // Logout actions end...

    // update user details...
    case UPDATE_USER_DATA:
      if (state?.userRole === "client") {
        return {
          ...state,
          userName: `${action?.payload?.userData?.firstName} ${action?.payload?.userData?.lastName}`,
          email: action?.payload?.userData?.email || state?.email,
          phoneNumber:
            action?.payload?.userData?.phoneNumber || state?.phoneNumber,
          companyName:
            action.payload?.userData?.companyName || state?.companyName,
          isBusinessProfile: action?.payload?.data?.isBusinessProfile,
          businessProfileId: action?.payload?.data?.businessProfileId,
          createdAt: action?.payload?.userData?.createdAt || state?.createdAt,
          resumeUrl: action?.payload?.userData?.resume || state?.resumeUrl,
          insuranceCertificate:
            action?.payload?.userData?.insuranceCertificate ||
            state?.insuranceCertificate,
          age: action?.payload?.userData?.age || state?.age,
          contractorType: action?.payload?.data?.contractorType,
          dateOfBirth:
            action?.payload?.userData?.dateOfBirth || state?.dateOfBirth,
          emergencyContactName:
            action?.payload?.userData?.emergencyContactName ||
            state?.emergencyContactName,
          emergencyContactNumber:
            action?.payload?.userData?.emergencyContactNumber ||
            state?.emergencyContactNumber,
        };
      } else if (
        state?.userRole === "admin" ||
        state?.userRole === "superAdmin"
      ) {
        return {
          ...state,
          userName: action.payload?.fullName,
          email: action.payload?.email,
          phoneNumber: action.payload?.mobile,
          companyName: action.payload?.companyName,
          createdAt: action.payload?.createdAt,
          userId: action.payload?._id,
          hasError: false,
          userRole: action.payload?.activeRole,
          activeRole: action.payload?.activeRole,
          resumeUrl: action.payload?.resume,
          insuranceCertificate: action.payload?.insuranceCertificate,
          age: action.payload?.age,
          dateOfBirth: action.payload?.dateOfBirth,
          contractorType: action?.payload?.data?.contractorType,
          emergencyContactName: action.payload?.emergencyContactName,
          emergencyContactNumber: action.payload?.emergencyContactNumber,
        };
      } else {
        return {
          ...state,
          userName: action?.payload?.userData?.fullName || `${state?.userName}`,
          email: action?.payload?.userData?.email || state?.email,
          phoneNumber:
            action?.payload?.userData?.phoneNumber || state?.phoneNumber,
          companyName:
            action.payload?.userData?.companyName || state?.companyName,
          createdAt: action?.payload?.userData?.createdAt || state?.createdAt,
          resumeUrl: action?.payload?.userData?.resume || state?.resumeUrl,
          insuranceCertificate:
            action?.payload?.userData?.insuranceCertificate ||
            state?.insuranceCertificate,
          age: action?.payload?.userData?.age || state?.age,
          contractorType: action?.payload?.data?.contractorType,
          dateOfBirth:
            action?.payload?.userData?.dateOfBirth || state?.dateOfBirth,
          emergencyContactName:
            action?.payload?.userData?.emergencyContactName ||
            state?.emergencyContactName,
          emergencyContactNumber:
            action?.payload?.userData?.emergencyContactNumber ||
            state?.emergencyContactNumber,
        };
      }

    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        loading: true,
        userToken: null,
        refreshToken: null,
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        deviceToken: action?.payload?.deviceToken,
        userToken: action.payload?.token,
        refreshToken: action.payload?.refreshToken,
        userName: action.payload?.data?.name,
        email: action.payload?.data?.email,
        phoneNumber: action.payload?.data?.mobile,
        companyName: action.payload?.data?.companyName,
        isBusinessProfile: action?.payload?.data?.isBusinessProfile,
        businessProfileId: action?.payload?.data?.businessProfileId,
        createdAt: action.payload?.data?.createdAt,
        isTwoFactorAuthentication:
          action.payload?.data?.isTwoFactorAuthentication,
        userId: action.payload?.data?.id,
        hasError: false,
        // Multi-role (VERIFY_OTP)
        userRole: action.payload?.data?.activeRole,
        activeRole: action.payload?.data?.activeRole,
        approvedRoles: action.payload?.data?.approvedRoles || [],
        pendingRoles: action.payload?.data?.pendingRoles || [],
        rolesData: action.payload?.data?.rolesData || {},
        isApproved: action.payload?.data?.isApproved,
        isSupportAgent: action.payload?.data?.isSupportAgent ?? state.isSupportAgent,
        canManageDeposits: action.payload?.data?.canManageDeposits,
        canManageFinancialDrafts: action.payload?.data?.canManageFinancialDrafts === true,
        canViewFinancialDashboard: action.payload?.data?.canViewFinancialDashboard === true,
        canViewPayrollDashboard: action.payload?.data?.canViewPayrollDashboard === true,
        canManageFinancialCloseout: action.payload?.data?.canManageFinancialCloseout === true,
        canManageRecruitment: action.payload?.data?.canManageRecruitment,
        isGustoApproved: action.payload?.data?.isGustoApproved,
        isADPCompleted: action.payload?.data?.isADPCompleted,
        smsPermissionStatus: action?.payload?.data?.smsPermissionStatus,
        termsAcceptedAt: action?.payload?.data?.termsAcceptedAt,
        isAgreementAccepted: action?.payload?.data?.isAgreementAccepted,
        resumeUrl: action.payload?.data?.resume,
        insuranceCertificate: action.payload?.data?.insuranceCertificate,
        age: action.payload?.data?.age,
        contractorType: action?.payload?.data?.contractorType,
        dateOfBirth: action.payload?.data?.dateOfBirth,
        emergencyContactName: action.payload?.data?.emergencyContactName,
        emergencyContactNumber: action.payload?.data?.emergencyContactNumber,
        emailPref: action?.payload?.data?.EmailNotificationPreference,
      };
    case VERIFY_OTP_FAILURE:
      return {
        ...state,
        loading: false,
        userToken: null,
        refreshToken: null,
        hasError: true,
      };

    // send oto to email
    case SEND_OTP_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case SEND_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        userId: action.payload,
      };
    case SEND_OTP_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // verify otp for forget password
    case VERIFY_FORGET_OTP_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case VERIFY_FORGET_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case VERIFY_FORGET_OTP_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // refresh token
    case REFRESH_TOKEN:
      return {
        ...state,
        userToken: action.payload,
      };

    // fetch user profile details
    case FETCH_USER_PROFILE_DETAILS_REQUEST:
      return {
        ...state,
        userProfileDetailsLoading: true,
      };

    case FETCH_USER_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        userProfileDetailsLoading: false,
      };

    case FETCH_USER_PROFILE_DETAILS_FAILURE:
      return {
        ...state,
        userProfileDetailsLoading: false,
      };

    case SET_2FA_REQUEST:
      return {
        ...state,
        isTwoFactorAuthenticationLoading: true,
      };

    case SET_2FA_SUCCESS:
      return {
        ...state,
        isTwoFactorAuthentication: action?.payload?.isTwoFactorAuthentication,
        isTwoFactorAuthenticationLoading: false,
      };

    case SET_2FA_FAILURE:
      return {
        ...state,
        isTwoFactorAuthenticationLoading: false,
      };

    // refresh user
    case REFRESH_USER:
      return {
        ...state,
        userName: action.payload?.fullName,
        email: action.payload?.email,
        phoneNumber: action.payload?.mobile,
        companyName: action.payload?.companyName,
        createdAt: action.payload?.createdAt,
        userId: action.payload?._id,
        hasError: false,
        userRole: action.payload?.activeRole,
          activeRole: action.payload?.activeRole,
      };

    // change notification prefrence
    case CHANGE_NOTIFICATION_REQUEST:
      return {
        ...state,
        sLoading: true,
      };

    case CHANGE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        sLoading: false,
        notificationPreference: {
          ...state.notificationPreference,
          ...action.payload?.emailNotificationPreference,
        },
      };
    case CHANGE_NOTIFICATION_FAILURE:
      return {
        ...state,
        sLoading: false,
      };

    case CHANGE_PUSH_NOTIFICATION_REQUEST:
      return {
        ...state,
        sLoading: true,
      };

    case CHANGE_PUSH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        sLoading: false,
        allDeviceToken: action?.payload?.deviceToken,
        deviceToken: action?.payload?.currentDeviceToken,
        notificationPreference: {
          ...state.notificationPreference,
          pushNotificationPreference:
            action.payload?.pushNotificationPreference,
        },
      };
    case CHANGE_PUSH_NOTIFICATION_FAILURE:
      return {
        ...state,
        sLoading: false,
      };

    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        userId: action.payload,
      };
    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // change password
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        pLoading: true,
      };

    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        pLoading: false,
      };

    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        pLoading: false,
      };

    // upload image
    case UPDATE_IMAGE_REQUEST:
      return {
        ...state,
      };
    case UPDATE_IMAGE_SUCCESS:
      return {
        ...state,
        imageUrl: action.payload,
      };
    case UPDATE_IMAGE_FAILURE:
      return {
        ...state,
      };

    // fetch contractor details
    case FETCH_CONTRACTOR_PROFILE_REQUEST:
      return {
        ...state,
        contractorLoading: true,
      };
    case FETCH_CONTRACTOR_PROFILE_SUCCESS:
      return {
        ...state,
        isApproved:
          "isApproved" in action?.payload
            ? action?.payload?.isApproved
            : state?.isApproved,
        imageUrl: action?.payload?.profileImage || state?.imageUrl,
        resumeUrl: action?.payload?.resume || state?.resumeUrl,
        insuranceCertificate:
          action?.payload?.insuranceCertificate || state?.insuranceCertificate,
        contractorDetails: {
          ...state?.contractorDetails,
          ...action.payload,
        },
        contractorLoading: false,
      };
    case FETCH_CONTRACTOR_PROFILE_FAILURE:
      UPDATE_CONTRACTOR_PROFILE_STEPS;
      return {
        ...state,
        contractorLoading: false,
      };

    // contractor profile steps
    case UPDATE_CONTRACTOR_PROFILE_STEPS: {
      return {
        ...state,
        ...(action?.payload?.auth || {}),
        contractorDetails: {
          ...state?.contractorDetails,
          ...(action?.payload?.contractorDetails || {}),
          contractorProfile: {
            ...state?.contractorDetails?.contractorProfile,
            [action?.payload?.contractorProfile?.key]:
              action?.payload?.contractorProfile?.value,
          },
        },
      };
    }

    // update contractor certifications
    case UPDATE_CONTRACTOR_CERTIFICATES: {
      return {
        ...state,
        contractorDetails: {
          ...state?.contractorDetails,
          certifications: action?.payload?.certifications,
        },
      };
    }

    case UPDATE_MULTIPLE_FIELDS_AUTH: {
      return {
        ...state,
        ...(action?.payload || {}),
      };
    }

    // accept contractor consent
    case ACCEPT_CONTRACTOR_CONSENT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ACCEPT_CONTRACTOR_CONSENT_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case ACCEPT_CONTRACTOR_CONSENT_SUCCESS:
      return {
        ...state,
        loading: false,
        smsPermissionStatus: true,
        termsAcceptedAt: true,
      };

    // accept contractor document
    case ACCEPT_CONTRACTOR_DOCUMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACCEPT_CONTRACTOR_DOCUMENTS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ACCEPT_CONTRACTOR_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        isAgreementAccepted: true,
      };
    }

    // help status toggle
    case TOGGLE_HELP_STATUS:
      return {
        ...state,
        helpStatus: action?.payload,
      };

    // update email preference
    case UPDATE_EMAIL_PREFERENECE_STATUS_REQUEST:
      return {
        ...state,
        sLoading: true,
      };
    case UPDATE_EMAIL_PREFERENECE_STATUS_FAILURE:
      return {
        ...state,
        sLoading: false,
      };
    case UPDATE_EMAIL_PREFERENECE_STATUS_SUCCESS:
      return {
        ...state,
        sLoading: false,
        emailPref: action?.payload?.data,
      };

    // client signup
    case CLIENT_SIGNUP_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case CLIENT_SIGNUP_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case CLIENT_SIGNUP_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // fetch profile success
    case FETCH_PROFILE_SUCCESS: {
      let contractorData = { ...state?.contractorDetails };
      let disableDashboard = false;
      if (action.payload?.data?.activeRole === userRoles.contractor) {
        let profileCompleted = false;

        if (
          action.payload?.contractorDetails?.contractorProfile
            ?.isContractorFormCompleted &&
          action.payload?.contractorDetails?.contractorProfile
            ?.isPersonalInformationAdded &&
          action.payload?.contractorDetails?.contractorProfile
            ?.isCareerGoalsAdded &&
          action.payload?.contractorDetails?.contractorProfile
            ?.isRoleInformationAdded
        ) {
          profileCompleted = true;
        }

        if (!action?.payload?.data?.isApproved) {
          disableDashboard = true;
        }

        contractorData.profileCompleted = profileCompleted;
        contractorData.contractorProfile =
          action.payload?.contractorDetails?.contractorProfile;
      }

      return {
        ...state,
        loading: false,
        userToken: state?.userToken,
        refreshToken: state?.refreshToken,
        deviceToken: state?.deviceToken,
        userName: action.payload?.data?.name,
        email: action.payload?.data?.email,
        phoneNumber: action.payload?.data?.mobile,
        allDeviceToken: action?.payload?.data?.deviceToken,
        companyName: action.payload?.data?.companyName,
        isBusinessProfile: action?.payload?.data?.isBusinessProfile,
        businessProfileId: action?.payload?.data?.businessProfileId,
        isTwoFactorAuthentication:
          action.payload?.data?.isTwoFactorAuthentication,
        createdAt: action.payload?.data?.createdAt,
        hasError: false,
        userId: action.payload?.data?.id,
        // Multi-role: getUserProfile does NOT return approvedRoles/activeRole
        // (only signIn). Preserve what is in state so it is not zeroed out after boot.
        userRole: action.payload?.data?.activeRole || state.activeRole,
        activeRole: action.payload?.data?.activeRole || state.activeRole,
        approvedRoles:
          action.payload?.data?.approvedRoles?.length
            ? action.payload?.data?.approvedRoles
            : state.approvedRoles || [],
        pendingRoles:
          action.payload?.data?.pendingRoles?.length
            ? action.payload?.data?.pendingRoles
            : state.pendingRoles || [],
        rolesData: action.payload?.data?.rolesData || state.rolesData || {},
        isApproved: action.payload?.data?.isApproved,
        isSupportAgent: action.payload?.data?.isSupportAgent ?? state.isSupportAgent,
        isGustoApproved: action.payload?.data?.isGustoApproved,
        isADPCompleted: action.payload?.data?.isADPCompleted,
        smsPermissionStatus: action?.payload?.data?.smsPermissionStatus,
        termsAcceptedAt: action?.payload?.data?.termsAcceptedAt,
        disableDashboard,
        imageUrl: action.payload?.data?.profileImageUrl,
        city: action?.payload?.data?.city,
        mailingAddress: action?.payload?.data?.mailingAddress,
        state: action?.payload?.data?.state,
        zipCode: action?.payload?.zipCode,
        notificationPreference: {
          ...action.payload?.data?.emailNotificationPreference,
          pushNotificationPreference:
            action.payload?.data?.pushNotificationPreference,
        },
        canPositionEdit: action?.payload?.data?.canPositionEdit,
        isAgreementAccepted: action?.payload?.data?.isAgreementAccepted,
        canManageGusto: action?.payload?.data?.canManageGusto,
        canManageDeposits: action?.payload?.data?.canManageDeposits,
        canManageFinancialDrafts: action?.payload?.data?.canManageFinancialDrafts === true,
        canViewFinancialDashboard: action?.payload?.data?.canViewFinancialDashboard === true,
        canViewPayrollDashboard: action?.payload?.data?.canViewPayrollDashboard === true,
        canManageFinancialCloseout: action?.payload?.data?.canManageFinancialCloseout === true,
        canManageRecruitment: action?.payload?.data?.canManageRecruitment,
        canViewCrewIdentityDocuments:
          action?.payload?.data?.canViewCrewIdentityDocuments,
        allowResendCredentials: action?.payload?.data?.allowResendCredentials,
        canUnflagContractors: action?.payload?.data?.canUnflagContractors,
        canUnrestrictContractors:
          action?.payload?.data?.canUnrestrictContractors,
        addAdpLink: action?.payload?.data?.addAdpLink,
        resumeUrl: action.payload?.data?.resume,
        insuranceCertificate: action.payload?.data?.insuranceCertificate,
        age: action.payload?.data?.age,
        contractorType: action?.payload?.data?.contractorType,
        dateOfBirth: action.payload?.data?.dateOfBirth,
        emergencyContactName: action.payload?.data?.emergencyContactName,
        emergencyContactNumber: action.payload?.data?.emergencyContactNumber,
        contractorDetails: contractorData,
        emailPref: action?.payload?.data?.EmailNotificationPreference,
      };
    }

    case FIREBASE_SUPPORT_STATUS:
      return {
        ...state,
        isFirebaseSupported: action?.payload?.isFirebaseSupported,
        isNotificationDenied: action?.payload?.isNotificationDenied,
      };

    case RESET_AUTH:
      return initialState;

    // Multi-role: switch active role (chama POST /switchActiveRole)
    case SWITCH_ACTIVE_ROLE_REQUEST:
      return { ...state, switchingRole: true };
    case SWITCH_ACTIVE_ROLE_SUCCESS:
      return {
        ...state,
        switchingRole: false,
        userToken: action.payload?.token || state.userToken,
        refreshToken: action.payload?.refreshToken || state.refreshToken,
        activeRole: action.payload?.activeRole,
        userRole: action.payload?.activeRole, // legacy sync
        approvedRoles: action.payload?.approvedRoles || state.approvedRoles,
      };
    case SWITCH_ACTIVE_ROLE_FAILURE:
      return { ...state, switchingRole: false };

    default:
      return state;
  }
};

export { authReducer, initialState };
